import(/* webpackMode: "eager" */ "/home/runner/work/rezervator-cms/rezervator-cms/src/app/auth/layout.tsx");
